export default class DomComponent {
    el;
    static refs = [];

    static defaultOpts = {
        cache: false
    };

    constructor(el, opts = {}) {

        if (!el) {
            return false;
        }

        if (!(el instanceof Node)) {

            if (!this.constructor.template) {
                console.error(this.constructor.name +
                    ' has no template associated with its class and no dom node passed in to its constrctor');
            }


            const html = this.constructor.template(el);
            const div = document.createElement('div');
            div.innerHTML = html;
            el = div.firstElementChild;
        }

        opts = Object.assign({}, DomComponent.defaultOpts, opts)

        this.el = el;
        this.el.classList.add('js');

        if (opts.cache) {
            this.ref = Math.random();
            this.el.dataset.ref = this.ref;
            DomComponent.refs[this.ref] = this;
        }
    }

    loaded() {
        this.el.classList.add('js-loaded');
    }

    emit(name, data) {
        const event = new CustomEvent(name, {
            detail: data
        })
        this.el.dispatchEvent(event);
    }

    listen(name, cb) {
        this.el.addEventListener(name, cb);
    }

    static getComponentByRef(ref) {
        return DomComponent.refs[ref];
    }

    static getEntryElements() {
        return document.querySelectorAll(this.selector);
    }

    static fromTemplate(data) {
        const html = this.template({
            data: data
        });
        const div = document.createElement('div');
        div.innerHTML = html;

        return new this(div.firstElementChild);
    }
}
